import { connect } from 'react-redux'
import cardRelationsSelector from './cardRelationsSelector'
import requestRemoveCardParent from '../../sagas/requestRemoveCardParent'
import requestRemoveCardSequence from '../../sagas/requestRemoveCardSequence'
import requestChangeCardDefaultParent from 'routes/Board/sagas/requestChangeCardDefaultParent'
import CardRelations from './CardRelations'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  cardRelationsSelector,
  {
    requestRemoveCardParent,
    requestRemoveCardSequence,
    requestChangeCardDefaultParent,
  }
)(CardRelations))
